"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.portexColor = exports.gold = exports.orange = exports.yellow = exports.green = exports.red = exports.cyan = exports.purple = exports.grey = exports.blue = void 0;
exports.blue = {
    900: "#000f33",
    800: "#011b66",
    700: "#002999",
    600: "#0137cc",
    500: "#0045ff",
    400: "#336aff",
    300: "#668fff",
    200: "#98b5ff",
    100: "#e9eefe",
};
exports.grey = {
    900: "#17222f",
    800: "#2d333b",
    700: "#434d58",
    600: "#5a6677",
    500: "#708093",
    400: "#8d99a8",
    300: "#b7bfc9",
    200: "#DDE1E6",
    100: "#e2e6e9",
    50: "#F7F8F9",
    base: "#cfd7e0",
};
exports.purple = {
    500: "#8024fa",
    300: "#A666FC",
    100: "#f2e5ff",
};
exports.cyan = {
    500: "#008bf1",
    100: "#e5f3fe",
};
exports.red = {
    500: "#e25050",
    100: "#FCEDEE",
};
exports.green = {
    500: "#16aa65",
    100: "#e7f6ef",
};
exports.yellow = {
    500: "#ffbf12",
    100: "#fff9e6",
};
exports.orange = {
    500: "#FF6262",
    100: "#ffecec",
};
exports.gold = {
    500: "#e28a06",
    400: "#fdad09",
    100: "#fff8df",
};
exports.portexColor = {
    blue900: exports.blue["900"],
    blue800: exports.blue["800"],
    blue700: exports.blue["700"],
    blue600: exports.blue["600"],
    blue500: exports.blue["500"],
    blue400: exports.blue["400"],
    blue300: exports.blue["300"],
    blue200: exports.blue["200"],
    blue100: exports.blue["100"],
    grey900: exports.grey["900"],
    grey800: exports.grey["800"],
    grey700: exports.grey["700"],
    grey600: exports.grey["600"],
    grey500: exports.grey["500"],
    grey400: exports.grey["400"],
    grey300: exports.grey["300"],
    grey200: exports.grey["200"],
    grey100: exports.grey["100"],
    grey50: exports.grey["50"],
    purple500: exports.purple["500"],
    purple300: exports.purple["300"],
    purple100: exports.purple["100"],
    cyan500: exports.cyan["500"],
    cyan100: exports.cyan["100"],
    red500: exports.red["500"],
    red100: exports.red["100"],
    green500: exports.green["500"],
    green100: exports.green["100"],
    yellow500: exports.yellow["500"],
    yellow100: exports.yellow["100"],
    orange500: exports.orange["500"],
    orange100: exports.orange["100"],
    gold500: exports.gold["500"],
    gold400: exports.gold["400"],
    gold100: exports.gold["100"]
};
//# sourceMappingURL=color.js.map